<template>
  <div>
    <Nav-bar :has_back="true" :has_right="false" title="提现记录"></Nav-bar>
    <div class="top-margin"></div>

    <van-pull-refresh v-model="state.loading" @refresh="onRefresh">
      <van-list
        v-model:loading="state.loading"
        :finished="state.finished"
        finished-text="没有更多了"
        @load="initData"
      >
        <div class="record-list">
          <div class="litem-v" v-for="list in state.list" :key="list">
            <div class="display_column">
              <span class="t-f14-c1a"
                >提现<span class="t-f16-c1a font-bold m-l-5">{{
                  list.amount
                }}</span></span
              >
              <span class="t-f12-c66 m-t-5">{{
                $filters.timeFormate(list.created_at)
              }}</span>
            </div>
            <div class="right display_column">
              <span :style="{ color: list.statusType }">{{
                list.statusName
              }}</span>
              <span
                class="t-f12-c28 m-t-5"
                v-if="list.status == 'rejected'"
                @click="showPopup(list.id)"
                >查看原因</span
              >
            </div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <van-popup v-model:show="show" >
      <div class="reject-view display_column">
        <span class="t-f16-c1a font-bold">拒绝原因</span>
        <span class="t-f14-c66 m-t-10">{{rejectAnalysis}}</span>
      </div>
        <img src="../../images/charging_package_topup_close.png" class="close" @click="show = false">
    </van-popup>
  </div>
</template>

<script>
import NavBar from "@/components/NavBar.vue";
import { reactive, ref } from "vue";
import ordersData from "@/utils/data.js";
import request from "@/api/request";
import httpHelper from "@/helpers/http_helper";

let state;
let pageCount = 1; //data page
let rejectAnalysis = ref("")
export default {
  components: {
    NavBar,
  },
  setup() {
    state = reactive({
      list: [],
      loading: false,
      finished: false,
    });
    const show = ref(false);
    const showPopup = (id) => {
      show.value = true;
      checkOrderById(id);
    };
    return { state, formatStatus, show, showPopup,rejectAnalysis };
  },
  // Vue  destroy
  unmounted() {
    pageCount = 1;
  },
  methods: {
    initData() {
      let filterData = {};
      filterData["page"] = pageCount;
      httpHelper.showLoading();

      request
        .getWithRecordList(filterData)
        .then((res) => {
          state.loading = false;
          httpHelper.hideLoading();
          //No more data
          if (res.data.results.length == 0) {
            state.finished = true;
            return;
          }
          // Initialization data
          if (pageCount == 1) {
            state.list.length = 0;
            state.finished = false;
          }
          //Marge data
          state.list = state.list.concat(formatStatus(res.data.results));
          //Number of request  page increase
          pageCount++;
        })
        .catch(() => {
          state.loading = false;
          httpHelper.hideLoading();
        });
    },
    //Pull refresh
    onRefresh() {
      //Reset page
      pageCount = 1;
      this.initData();
    },
  },
};
function checkOrderById(id) {
  let array = state.list;
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    if(element.id === id){
      rejectAnalysis.value = element.message
    }
  }
}
function formatStatus(array) {
  for (let index = 0; index < array.length; index++) {
    const element = array[index];
    element.statusName = ordersData.withdrawalStatus(element.status);
    element.statusType = textColor(element.status);
  }
  return array;
}
function textColor(status) {
  var map = {
    pending: "#F19321", //审核种
    rejected: "#FB0006", //拒绝
    done: "#00B68A", //通过
  };
  return map[status];
}
</script>

<style lang="scss" scoped  >
::v-deep .van-popup {
  border-radius: 10px;
  text-align: left;
  left: 20px;
  right: 20px;
   transform: translateY(-50%);
}
.reject-view {
  padding: 20px;
  border-radius: 10px;
}
.right {
  position: absolute;
  right: 20px;
  top: 50%;
  text-align: center;
  transform: translateY(-50%);
}
.record-list {
  padding-top: 10px;
  height: 100vh;
}
.litem-v {
  padding: 20px;
  position: relative;
  margin-top: 1px;
  background: #fff;
}
.close{
  position: absolute;
  top: 10px;
  right: 10px;
  width: 25px;
  height: 25px;
}
</style>